import { Routes, Route, Navigate } from 'react-router-dom';
import { AccountPanel, LoginForm, CreateAccountForm } from './focuswin/script/components';
import { intrComp, suppComp } from './focuswin/script/comp-data';

export default function NonAuthContent() {
  return (
    <Routes>
      <Route
        path='/login' 
        element={
          <AccountPanel title="로그인" intrComp={intrComp} suppComp={suppComp}>
            <LoginForm />
          </AccountPanel>
        }
      />
      <Route path='*' element={<Navigate to={'/login'} />}></Route>
    </Routes>
  );
}
